module.exports = __webpack_public_path__ + "static/media/archibot-amoureux.0552af70.gif";